import { apiLog } from './logUtil'
import { kyApi } from 'api'
import { getURI } from './stringUtil'

/**
 * レスポンス共通型
 */
export type response<Option> = {
  body: Option
  message: string
  error: boolean
  alert: boolean
  end: boolean // システムエラー発生時にTRUE　ログイン画面に戻される
}

/**
 * 新ライブラリAPI関数
 * ky導入に伴い入替
 */
export const postAPI = async <T extends Object, U extends Object>(
  url: string, //
  req: T,
  func: (res: response<U>) => void,
  errFunc: () => void = () => {},
  finalFunc: () => void = () => {},
) => {
  let isError = false
  const token = sessionStorage.getItem('token')
  await kyApi(token!)
    .post(getURI(url), {
      json: { req },
    })
    .json<response<U>>()
    .then((res) => {
      if (res.error || res.end) throw new Error()
      func(res)
    })
    .catch((err: Error) => {
      console.error(err)
      errFunc()
      isError = true
    })
    .finally(() => {
      apiLog(url)
      finalFunc()
    })
  return isError
}

/**
 * フォーム送信用(リクエストをボディに入れる)
 * ファイルアップロードはこちらを使う
 */
export const postFormAPI = async <U extends Object>(
  url: string, //
  req: FormData,
  func: (res: response<U>) => void,
  errFunc: () => void = () => {},
  finalFunc: () => void = () => {},
) => {
  const token = sessionStorage.getItem('token')
  await kyApi(token!)
    .post(getURI(url), { body: req })
    .json<response<U>>()
    .then(func)
    .catch((err: Error) => {
      console.error(err)
      errFunc()
    })
    .finally(() => {
      apiLog(url)
      finalFunc()
    })
}

/**
 * SWR用Fetcher
 * @param url
 * @param req
 * @returns
 */
export const postFetcher = <U extends Object>(url: string = '/', req: any = {}): (() => Promise<response<U>>) => {
  const token = sessionStorage.getItem('token')
  return async () =>
    await kyApi(token!)
      .post(getURI(url), { json: { req } })
      .json<response<U>>()
      .then((res) => res)
}

/**
 * 待機関数
 * @param ms 待機時間(ミリ秒)
 * @returns
 */
export const wait = async (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))
